if (!customElements.get('wt-subscription-selector')) {
  customElements.define('wt-subscription-selector', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.select = this.querySelector('select[name="selling_plan"]');
      this.total = this.querySelector('[data-wt-plan-total]');
      this.error = this.querySelector('[data-wt-plan-error]');
      if (!this.form || !this.select) return;
      this.handleChange = (event) => {
        if (event.target.name === 'id') this.updateVariant(event.target.value);
        if (event.target === this.select) this.updateSummary();
      };
      this.guardSubmit = (event) => {
        if (!this.select.value) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.error.hidden = false;
          this.select.focus();
        }
      };
      this.form.addEventListener('change', this.handleChange);
      this.form.addEventListener('submit', this.guardSubmit, true);
      this.updateSummary();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('change', this.handleChange);
      this.form?.removeEventListener('submit', this.guardSubmit, true);
    }
    updateVariant(variantId) {
      const previous = this.select.value;
      const template = Array.from(this.querySelectorAll('template[data-variant-id]')).find(item => item.dataset.variantId === String(variantId));
      this.select.replaceChildren();
      if (template) this.select.append(template.content.cloneNode(true));
      if (Array.from(this.select.options).some(option => option.value === previous)) this.select.value = previous;
      this.updateSummary();
    }
    updateSummary() {
      const option = this.select.selectedOptions[0];
      this.total.textContent = option?.dataset.total || '';
      this.total.hidden = !option;
      this.error.hidden = Boolean(option?.value);
    }
  });
}
